	export enum OrderLineStatusEnum {
		Pending = 1,
		Ordered = 2,
		ReadyToFulfill = 3,
		OnTrial = 4,
		Fulfilled = 5,
		PendingOrder = 7,
		PendingReturn = 8,
		RepairInShop = 9,
		Exchanged = 10,
		PendingReplacement = 11,
		NoSale = 12,
		Canceled = 13,
		Voided = 14,
		ReturnedToStock = 15,
		ReturnedToManufacturer = 16
	}
